import Series from './Series.vue';
import Month from './Month.vue';
import Efficiency from './Efficiency.vue';
import Filter from './Filter.vue';
import StoreSale from './StoreSale.vue';
export default {
    Efficiency,
    Series,
    Month,
    Filter,
    StoreSale
}



// WEBPACK FOOTER //
// ./src/components/Report/index.js